/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./users.vue?vue&type=template&id=3996d544&scoped=true&"
import script from "./users.vue?vue&type=script&lang=ts&"
export * from "./users.vue?vue&type=script&lang=ts&"
import style0 from "./users.vue?vue&type=style&index=0&id=3996d544&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3996d544",
  null
  
)

export default component.exports